const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const LightHelmet = require('../../../game_items/equipment/helmet/LightHelmet.js');
const LightTorsoe = require('../../../game_items/equipment/torsoe/LightTorsoe.js');
const LightBoots = require('../../../game_items/equipment/boots/LightBoots.js');
const Trinket = require('../../../game_items/equipment/off_hand/Trinket.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const goblin_elementalist = (level) => {
  const handle = 'goblin_elementalist';
  const types = ['goblin', 'humanoid', 'magic'];
  const AI_PRIORITIES = ['dps_ranged', 'interference', 'dps_close', 'support', 'tank'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(LightHelmet, level),
          ItemGenerator.getCavernsMobItem(LightTorsoe, level),
          ItemGenerator.getCavernsMobItem(LightBoots, level),
          ItemGenerator.getCavernsMobItem(Trinket, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'goblin_elementalist_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          burning_hands: {
            handle: 'burning_hands',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          lightning: {
            handle: 'lightning',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          mana_node: {
            handle: 'mana_node',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          ice_nine: {
            handle: 'ice_nine',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          molotov_cocktail: {
            handle: 'molotov_cocktail',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(9 + bound_level * 1.1 + Math.random() * 3),
      perception: Math.round(6 + bound_level * 0.7 + Math.random() * 3),
      mana: Math.round(10 + bound_level * 1.2 + Math.random() * 3),
      toughness: Math.round(5 + bound_level * 0.5 + Math.random() * 3),
      strength: Math.round(4 + bound_level * 0.35 + Math.random() * 3),
      willpower: Math.round(9 + bound_level * 1.1 + Math.random() * 3),
      dexterity: Math.round(6 + bound_level * 0.75 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 900,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'burning_hands' },
        { value: 'lightning' },
        { value: 'mana_node' },
        { value: 'ice_nine' },
        { value: 'molotov_cocktail' },
      ],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = goblin_elementalist;
